import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {SettingsCustomFieldsPagesEnum} from '../../../models/url/settingsUrlModel';
import {CustomFieldsTableMultiSelectDeleteActionContainer} from './actions/customFieldsTableMultiSelectDeleteActionContainer';

/*
 * Props.
 */

interface CustomFieldsTableActionsProps {
  tabPage: SettingsCustomFieldsPagesEnum;
  onSuccessfulDelete: HandlerOf<ReactNode>;
}

/*
 * Style.
 */

const StyledCustomFieldsTableActionsContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

/*
 * Component.
 */

export const CustomFieldsTableActions: FC<CustomFieldsTableActionsProps> = ({
  tabPage,
  onSuccessfulDelete,
}) => (
  <StyledCustomFieldsTableActionsContainerDiv>
    <CustomFieldsTableMultiSelectDeleteActionContainer
      tabPage={tabPage}
      onSuccessfulDelete={onSuccessfulDelete}
    />
  </StyledCustomFieldsTableActionsContainerDiv>
);
